import { t } from "@travily/i18n";
import type Badge from "@travily/types/models/BadgesRow";
import { DialogTitle } from "@ui/components/Dialog";
import { useBreakpoint } from "@ui/hooks/use-breakpoint";
import { PassportBook } from "./components/PassportBook";
import { PassportNotepad } from "./components/PassportNotepad";

export interface BadgesModalProps {
  badges: Badge[];
  onClose: () => void;
}

/**
 * "View all badges" passport experience. Desktop is an open-book spread with
 * paged navigation; mobile is a scrolling spiral notepad inside a bottom sheet.
 * The Dialog is opened with `chrome="bare"` so the illustration is the only
 * chrome — this component therefore supplies the Dialog's accessible name itself.
 */
export function BadgesModal({ badges, onClose }: BadgesModalProps) {
  // Same breakpoint the Dialog uses to pick its presenter (sheet vs dialog), so
  // the surface and its contents always agree.
  const isDesktop = useBreakpoint("md");

  return (
    <>
      {/* Dialog accessible name (Silk wires aria-labelledby) — neither surface uses a Dialog.Header. */}
      <DialogTitle className="sr-only">{t("passport.badges.modal.title")}</DialogTitle>
      {isDesktop ? (
        <PassportBook badges={badges} onClose={onClose} />
      ) : (
        <PassportNotepad badges={badges} onClose={onClose} />
      )}
    </>
  );
}
